import { InitialState } from "../initialState";

const AccessReducer = (state=InitialState, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                ...state,
                loginDetails: action.payload
            }
        case 'LOGIN_RESET':
            return {
                ...state,
                loginDetails: action.payload,
                logoutDetails: action.payload,
            }
        case 'LOGOUT':
            return {
                ...state,
                logoutDetails: action.payload
            }
        default:
            return state
    }
}

export default AccessReducer